import { createActionTypes } from '../../../util/createLifeomicActionTypes';

export default createActionTypes(['COHORTS_PAGE_SET_SEARCH']);
